import { TranslateService } from '@ngx-translate/core';

export class GenderUtils {
  private static translateService: TranslateService;

  // Genders with translation keys
  private static readonly GENDERS: {
    [key: number]: { id: number; name: string };
  } = {
    1: { id: 1, name: 'other' },
    2: { id: 2, name: 'male' },
    3: { id: 3, name: 'female' },
  };

  private static readonly GENDER_TRANSLATION_KEYS: { [key: number]: string } = {
    1: 'other',
    2: 'male',
    3: 'female',
  };

  static async initializeTranslateService(service: TranslateService) {
    this.translateService = service;

    service.onLangChange.subscribe(() => {
      this.updateGenderTranslations();
    });

    await this.updateGenderTranslations();
  }

  static updateGenderTranslations() {
    for (const key of Object.keys(this.GENDERS)) {
      const gender = this.GENDERS[+key];
      const translationKey = this.GENDER_TRANSLATION_KEYS[+key];

      if (gender && translationKey && this.translateService) {
        gender.name = this.translateService.instant(translationKey);
      }
    }
  }

  static getGender(id: number): { id: number; name: string } | undefined {
    return this.GENDERS[id];
  }

  static getGenderName(id: number): string {
    const translationKey = this.GENDER_TRANSLATION_KEYS[id];
    if (translationKey && this.translateService) {
      return this.translateService.instant(translationKey);
    }
    return 'Unknown';
  }

  static getGenderId(name: string): number | undefined {
    const gender = Object.values(this.GENDERS).find(
      (g) => g.name.toLowerCase() === name.toLowerCase()
    );
    return gender ? gender.id : undefined;
  }

  static getAllGenders(): Array<{ id: number; name: string }> {
    if (this.translateService) {
      this.updateGenderTranslations();
    }
    return Object.values(this.GENDERS);
  }
}
